/* List Of all the API URLS to be used to get DATA */
export default {
	tenantName: 'Women Power',
	forgotPasswordFormHeaderText: 'Recover Your Password',
	razorPayKey: 'rzp_test_A7i5v1J2InFME3',
	// razorPayKey: 'rzp_live_Lz5RTLAqxseMRy',
	shippingCharge: 26
}
